"use client";

import { c as _c } from "react/compiler-runtime";
import CreateDropMetadataItems from "@/components/drops/create/utils/metadata/CreateDropMetadataItems";
import { DropMetadata } from "@/entities/IDrop";
import { useState } from "react";
export default function CreateDropFullMobileMetadata(t0) {
  const $ = _c(22);
  const {
    metadata,
    onMetadataEdit,
    onMetadataRemove
  } = t0;
  const [key, setKey] = useState(null);
  const [value, setValue] = useState(null);
  let t1;
  if ($[0] !== key || $[1] !== onMetadataEdit || $[2] !== value) {
    t1 = e => {
      e.preventDefault();
      if (key && value) {
        onMetadataEdit({
          data_key: key,
          data_value: value
        });
        setKey(null);
        setValue(null);
      }
    };
    $[0] = key;
    $[1] = onMetadataEdit;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSubmit = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label className="tw-block tw-font-medium tw-text-iron-300 tw-text-sm">Metadata</label>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== metadata || $[6] !== onMetadataRemove) {
    t3 = <CreateDropMetadataItems items={metadata} onMetadataRemove={onMetadataRemove} />;
    $[5] = metadata;
    $[6] = onMetadataRemove;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = key ?? "";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e_0 => setKey(e_0.target.value);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <input type="text" placeholder="Category" value={t4} onChange={t5} maxLength={100} className="tw-form-input tw-appearance-none tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-2.5 tw-pr-3 tw-bg-iron-800 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-bg-iron-900 focus:tw-ring-1 focus:tw-ring-inset hover:tw-ring-iron-700 focus:tw-ring-primary-400 tw-text-md tw-leading-6 tw-transition tw-duration-300 tw-ease-out" />;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = value ?? "";
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_1 => setValue(e_1.target.value);
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <input type="text" placeholder="Value" value={t7} onChange={t8} maxLength={500} className="tw-form-input tw-appearance-none tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-2.5 tw-pr-3 tw-bg-iron-800 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-bg-iron-900 focus:tw-ring-1 focus:tw-ring-inset hover:tw-ring-iron-700 focus:tw-ring-primary-400 tw-text-md tw-leading-6 tw-transition tw-duration-300 tw-ease-out" />;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <button type="submit" className="tw-text-sm tw-font-semibold tw-inline-flex tw-items-center tw-rounded-lg tw-bg-iron-800 tw-px-3 tw-py-2 tw-text-iron-300 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-border-0 tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-bg-iron-700 focus:tw-z-10 tw-transition tw-duration-300 tw-ease-out">Add</button>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== onSubmit || $[16] !== t6 || $[17] !== t9) {
    t11 = <form onSubmit={onSubmit} className="tw-space-y-3 lg:tw-space-y-0">{t6}{t9}{t10}</form>;
    $[15] = onSubmit;
    $[16] = t6;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t3) {
    t12 = <div>{t2}{t3}{t11}</div>;
    $[19] = t11;
    $[20] = t3;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}